import { PropsWithChildren } from 'react';

import { MessagesContextType } from './types';
import { MessagesContext } from './context';

export const MessagesProvider = ({
  children,
  contextValue
}: PropsWithChildren<{ contextValue: MessagesContextType }>) => {
  return <MessagesContext.Provider value={contextValue}>{children}</MessagesContext.Provider>;
};
